import React from 'react';

const ParamKnobs = () => {
    return (
      <React.Fragment>
        <div className="sw4 sw4__1">
          <div className="sw4__shadow"></div>
          <div className="switch"></div>
          <div className="switch__frame"></div>
          <div className="switch__rect"></div>
        </div>
        <div className="sw4 sw4__2">
          <div className="sw4__shadow"></div>
          <div className="switch"></div>
          <div className="switch__frame"></div>
          <div className="switch__rect"></div>
        </div>
        <div className="sw4 sw4__3">
          <div className="sw4__shadow"></div>
          <div className="switch"></div>
          <div className="switch__frame"></div>
          <div className="switch__rect"></div>
        </div>
        <div className="sw4 sw4__4">
          <div className="sw4__shadow"></div>
          <div className="switch"></div>
          <div className="switch__frame"></div>
          <div className="switch__rect"></div>
        </div>
      </React.Fragment>
    );
  };

export default ParamKnobs;